import React from "react";
import "~/components/cards/hospitals/HospitalCard.scss";
import { IHospital } from "~/types/hospital";

type Props = {
  hospitalData: IHospital;
  onClick: (id: number) => void;
};

const HospitalCard: React.FC<Props> = ({ ...props }) => {
  return (
    <div
      onClick={() => props.onClick(props.hospitalData.idHospital)}
      className="mo-card"
    >
      <div className="mo-card__icon-container">
        <span className="mo-card__icon-wrap">
          <img
            className="mo-card__icon"
            width="171"
            height="119"
            src="https://onlinezdrav.ru/assets/hospital.svg"
            alt={props.hospitalData.organisationName}
          />
        </span>
      </div>

      <div className="mo-card__title-container">
        <h3 className="mo-card__title">
          {props.hospitalData.organisationName}
        </h3>
        {/* <p className="mo-card__desc">{props.hospitalData.organisationName}</p> */}
      </div>

      <div className="mo-card__info-container">
        <div className="mo-card__info">
          <img
            className="mo-card__info-icon"
            src="https://onlinezdrav.ru/assets/location.svg"
            alt="location"
          />
          <span> Адрес: {props.hospitalData.address} </span>
        </div>
        <div className="mo-card__info">
          <img
            className="mo-card__info-icon"
            src="https://onlinezdrav.ru/assets/hospital-icon.svg"
            alt="hospital-icon"
          />
          <span>Государственное учреждение</span>
        </div>
      </div>
    </div>
  );
};

export default HospitalCard;
